import { render, staticRenderFns } from "./insurePage.vue?vue&type=template&id=49f33ba5&scoped=true&"
import script from "./insurePage.vue?vue&type=script&lang=js&"
export * from "./insurePage.vue?vue&type=script&lang=js&"
import style0 from "./insurePage.vue?vue&type=style&index=0&id=49f33ba5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f33ba5",
  null
  
)

export default component.exports